import { render } from "./ProductGalleryTags.vue?vue&type=template&id=1298a842"
import script from "./ProductGalleryTags.vue?vue&type=script&lang=js"
export * from "./ProductGalleryTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__